import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", id: "nav-home" },
  { to: "/jobs", label: "Jobs", id: "nav-jobs" },
  { to: "/about", label: "About", id: "nav-about" },
  { to: "/services", label: "Services", id: "nav-services" },
  { to: "/signup", label: "Join Network", id: "nav-signup" },
  { to: "/contact", label: "Contact", id: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 border-b border-[#DCD7C9]/60 backdrop-blur-xl bg-[#F9F6F0]/80"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="brand-logo"
          className="font-display font-semibold text-lg tracking-tight text-[#1A2E24] flex items-center gap-2"
        >
          <span className="inline-block h-2.5 w-2.5 rotate-45 bg-[#D35400]" />
          Tool Cool <span className="text-[#5C6B64] hidden sm:inline">/ Farm & Homestead Experts</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              end
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? "text-[#1A2E24] font-medium" : "text-[#5C6B64] hover:text-[#1A2E24]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/jobs"
            data-testid="cta-browse-jobs"
            className="bg-[#1A2E24] text-[#F9F6F0] px-5 py-2.5 text-sm font-medium hover:bg-[#2C4A3B] transition-transform hover:-translate-y-0.5"
          >
            Browse Jobs
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#1A2E24]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#DCD7C9]/60 bg-[#F9F6F0]">
          <nav className="flex flex-col p-6 gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`m-${l.id}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-[#1A2E24] font-medium" : "text-[#5C6B64]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
